<mat-card class="settingsBody">
    <div>
        <span class="settings-heading">Holiday Hours</span>
    </div>
    <div class="select-heading" style="padding-top: 16px; padding-left: 0; padding-bottom: 0;">
        Enter Holidays where the business hours differ from the default Business Day Hours.
    </div>
    <div style="display: flex; flex-direction: row;">
        <div class="'padding-24">
            <div class="padding-16-top-bottom">
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label> Find Holiday </mat-label>
                    <input
                        matInput
                        [(ngModel)]="holidaySearchTerm"
                        class="search-field"
                        #holidaySearchBox
                        (ngModelChange)="filterHolidays()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <div class="employee-add-button-area float-right">
                    <button type="button" mat-raised-button (click)="addHoliday()">
                        <i class="fal fa-plus-square" A></i>
                        &nbsp; ADD HOLIDAY
                    </button>
                </div>
            </div>
            <div style="min-height: 450px;">
                <kendo-grid
                    id="kendoHolidayGrid"
                    [data]="view"
                    [loading]="loading"
                    [height]="616"
                    class="holiday-grid"
                    [pageSize]="pageSize"
                    [skip]="skip"
                    (dataStateChange)="onStateChange($event)"
                    (edit)="editHandler($event)"
                    (cancel)="cancelHandler($event)"
                    (save)="saveHandler($event)"
                    (remove)="removeHandler($event)"
                    (add)="addHandler($event)"
                    [navigable]="true"
                    [sortable]="{ mode: 'single', allowUnsort: false }"
                    [sort]="holidayEntrySort"
                    (sortChange)="sortChange($event)"
                    [pageable]="{
                        info: true,
                        type: type,
                        pageSizes: true,
                        previousNext: true
                    }"
                    [scrollable]="false"
                    (pageChange)="holidayPageChange($event)"
                >
                    <ng-template kendoGridNoRecordsTemplate>
                        <div class="no-data-message-area" *ngIf="noHolidaysForCompany">
                            <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                        </div>
                    </ng-template>
                    <!-- Holiday Date -->
                    <kendo-grid-column
                        field="holidayDate"
                        editor="date"
                        title="Holiday Date"
                        [headerClass]="'header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [format]="{ date: 'short' }"
                    >
                        <ng-template kendoGridCellTemplate let-selectedHoliday>
                            <div>
                                {{ selectedHoliday.holidayDate | date: 'MM/dd/yyyy':'UTC' }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Number of Hours -->
                    <kendo-grid-column
                        field="nbrOfHours"
                        editor="numeric"
                        title="Number of Hours"
                        [headerClass]="'header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [decimals]="2"
                        [step]="0.25"
                        [min]="0.0"
                        [max]="8.0"
                        [format]="'n2'"
                    >
                        <ng-template kendoGridCellTemplate let-selectedHoliday>
                            <div>
                                {{ selectedHoliday.nbrOfHours | number: '1.2-2' }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Holiday Name / Comment -->
                    <kendo-grid-column
                        field="holiday"
                        title="Comment"
                        [headerClass]="'header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [footerClass]="'text-color-black'"
                        [footerStyle]="{ 'text-align': 'left' }"
                    >
                    </kendo-grid-column>
                    <!-- Command Column -->
                    <kendo-grid-command-column
                        title=""
                        width="320"
                        [headerClass]="'header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-isNew="isNew">
                            <button
                                type="button"
                                class="btn-w-100"
                                mat-stroked-button
                                kendoGridEditCommand
                                raised
                            >
                                Edit
                            </button>
                            <button
                                type="button"
                                class="btn-w-100"
                                mat-stroked-button
                                color="warn"
                                kendoGridRemoveCommand
                                class="second-button"
                                outlined
                            >
                                Remove
                            </button>
                            <button
                                type="button"
                                mat-stroked-button
                                class="btn-w-100 button-green"
                                kendoGridSaveCommand
                                [disabled]="formGroup?.invalid"
                            >
                                {{ isNew ? 'Add' : 'Update' }}
                            </button>
                            <button
                                type="button"
                                class="btn-w-100"
                                mat-stroked-button
                                kendoGridCancelCommand
                                class="second-button"
                                outlined
                            >
                                {{ isNew ? 'Discard changes' : 'Cancel' }}
                            </button>
                        </ng-template>
                    </kendo-grid-command-column>
                    <ng-template kendoPagerTemplate>
                        <kendo-pager-prev-buttons
                            class="text-color-black"
                        ></kendo-pager-prev-buttons>
                        <kendo-pager-input class="text-color-black"></kendo-pager-input>
                        <kendo-pager-info class="text-color-black"></kendo-pager-info>
                        <kendo-pager-next-buttons
                            class="text-color-black"
                        ></kendo-pager-next-buttons>
                        <kendo-pager-page-sizes
                            class="text-color-black"
                            [pageSizes]="[10]"
                        ></kendo-pager-page-sizes>
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
    </div>
</mat-card>
